export type TagTone = "green" | "blue" | "amber" | "neutral";

const TAG_CLASSES: Record<TagTone, string> = {
  green: "bg-emerald-100 text-emerald-700",
  blue: "bg-blue-100 text-blue-700",
  amber: "bg-amber-100 text-amber-800",
  neutral: "bg-neutral-100 text-content-secondary",
};

export function Tag({
  tone,
  children,
}: {
  tone: TagTone;
  children: React.ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs whitespace-nowrap ${TAG_CLASSES[tone]}`}
    >
      {children}
    </span>
  );
}
